/* tslint:disable */
/* eslint-disable */
/**
 * Yaway API
 * Yaway API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Contact info
 * @export
 * @interface ApiContact
 */
export interface ApiContact {
    /**
     * 
     * @type {string}
     * @memberof ApiContact
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ApiContact
     */
    phonePrefix?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiContact
     */
    phone: string;
    /**
     * 
     * @type {string}
     * @memberof ApiContact
     */
    email?: string;
}

export function ApiContactFromJSON(json: any): ApiContact {
    return ApiContactFromJSONTyped(json, false);
}

export function ApiContactFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiContact {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'phonePrefix': !exists(json, 'phonePrefix') ? undefined : json['phonePrefix'],
        'phone': json['phone'],
        'email': !exists(json, 'email') ? undefined : json['email'],
    };
}

export function ApiContactToJSON(value?: ApiContact | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'phonePrefix': value.phonePrefix,
        'phone': value.phone,
        'email': value.email,
    };
}

